import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (!e.target.closest("nav")) setMenuOpen(false);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [menuOpen]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const linkClass = ({ isActive }) => "nav-link" + (isActive ? " active" : "");
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav>
      <NavLink to="/" className="logo">
        PK<span>.</span>
      </NavLink>

      <div className="nav-links">
        <NavLink to="/" end className={linkClass}>Home</NavLink>
        <NavLink to="/experience" className={linkClass}>Experience</NavLink>
        <NavLink to="/projects" className={linkClass}>Projects</NavLink>
        <NavLink to="/skills" className={linkClass}>Skills</NavLink>
        <NavLink to="/contact" className={linkClass}>Contact</NavLink>
        <NavLink to="/casestudy" className={linkClass}>Case Study</NavLink>
      </div>

      <a
        href="/Pratiksha_Kharkar_Resume.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="hire-btn desktop-only"
      >
        Resume ✦
      </a>

      <button
        className={menuOpen ? "hamburger open" : "hamburger"}
        onClick={() => setMenuOpen(function(prev) { return !prev; })}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={menuOpen ? "mobile-menu open" : "mobile-menu"}>
  <NavLink to="/" end className={linkClass} onClick={handleLinkClick}>Home</NavLink>
  <NavLink to="/experience" className={linkClass} onClick={handleLinkClick}>Experience</NavLink>
  <NavLink to="/projects" className={linkClass} onClick={handleLinkClick}>Projects</NavLink>
  <NavLink to="/skills" className={linkClass} onClick={handleLinkClick}>Skills</NavLink>
  <NavLink to="/contact" className={linkClass} onClick={handleLinkClick}>Contact</NavLink>
  <NavLink to="/casestudy" className={linkClass} onClick={handleLinkClick}>Case Study</NavLink>
  <a
    href="/Pratiksha_Kharkar_Resume.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="mobile-resume"
    onClick={handleLinkClick}
  >
    Resume ✦
  </a>
</div>


    </nav>
  );
}